var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('SuketIgdPage',{attrs:{"register":_vm.register,"dtResume":_vm.stateresume,"tabShow":_vm.showingTab},on:{"pageTab":_vm.showTab}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }